import View from 'views/base/view';
import BlocksView from 'views/block/block-collection-view';
import BrowserCourseEditor from 'views/browser-course-editor/browser-course-editor-view';
import Chaplin from 'chaplin';
import $ from 'jquery';
import CustomPageService from 'services/course-handler-services/custom-page-service';
import LocaleService from 'services/loader-handler-services/locale-service';
import ForgeEditorTemplate from 'views/forge-editor/templates/forge-editor';
import ForgeMenuItemView from 'views/forge-editor/forge-menu-item-view';
import BlockExporter from 'lib/export';

const ForgeEditorView = View.extend({
  template: ForgeEditorTemplate,
  container: 'body',
  autoRender: true,
  autoAttach: true,
  listen: {
    addedToDOM: 'loaded',
    'page:state:loaded mediator': 'checkForBrowserEditor',
  },
  checkForBrowserEditor: function () {
    if (this.hasQueryStr && !this.browserEditor) {
      this.browserEditor = new BrowserCourseEditor();
    }
  },
  initialize: function () {
    this.hasQueryStr = arguments[0];
    this.curElem = { $hoverElem: [], $currentElem: [] };
    this.seqno = 0;
    View.prototype.initialize.apply(this, arguments);
  },
  loaded: function () {
    this.setFloater();
    this.setMouseEvents();
    this.setPostMessage();
    this.announceExportSupport();
  },
  announceExportSupport: function () {
    // version 2 adds mode, meta and the transcript article; Forge hides formats that need it from older builds
    this.postToForge({ enabled: true, version: 2 });
  },
  getContextMenuPostion: function (evt, contextMenu) {
    const INSET = 10; // # of pixels toward middle of rectangle
    const mousePos = { x: evt.pageX, y: evt.pageY };
    const menuSize = { x: contextMenu.outerWidth(), y: contextMenu.outerHeight() };
    const menuPos = {};
    if (mousePos.x + menuSize.x > $(window).width() + $(window).scrollLeft()) {
      menuPos.x = mousePos.x - menuSize.x + INSET;
    } else {
      menuPos.x = mousePos.x - INSET;
    }

    if (mousePos.y + menuSize.y > $(window).height() + $(window).scrollTop()) {
      menuPos.y = mousePos.y - menuSize.y + INSET;
    } else {
      menuPos.y = mousePos.y - INSET;
    }
    return menuPos;
  },
  setFloater: function () {
    this.$floater = $('#forge-editor-holder #floater');
    this.subscribeEvent('forge:block:contextmenu', this.setContextMenu);
    this.subscribeEvent('forge:block:contextmenu', evt => {
      // Use setTimeout here because we won't know the height of the floater
      // until all the propagated blocks have time to stack.
      setTimeout(() => {
        const position = this.getContextMenuPostion(evt, this.$floater);
        this.$floater.css({
          top: `${position.y}px`,
          left: `${position.x}px`,
          display: 'block',
        });
      }, 0);
      return false;
    });
    this.$floater.mouseleave(evt => {
      this.$floater.css({
        display: 'none',
      });
      $('#clicked-elems').empty();
      this.publishEvent('forge:menu:exit');
    });
  },
  getXPathTo: function (element) {
    if (element.id !== '') {
      return `id("${element.id}")`;
    }
    if (element === document.body) {
      return element.tagName;
    }
    let ix = 0;
    const siblings = element.parentNode.childNodes;
    for (let i = 0; i < siblings.length; i++) {
      const sibling = siblings[i];
      if (sibling === element) {
        return `${this.getXPathTo(element.parentNode)}/${element.tagName}[${ix + 1}]`;
      }
      if (sibling.nodeType === 1 && sibling.tagName === element.tagName) {
        ix++;
      }
    }
  },
  getElementByXPath: function (path) {
    return new XPathEvaluator().evaluate(
      path,
      document.documentElement,
      null,
      XPathResult.FIRST_ORDERED_NODE_TYPE,
      null
    ).singleNodeValue;
  },
  setMouseEvents: function () {
    this.subscribeEvent('forge:block:mouseenter', evt => {
      if (!$(this.curElem.$hoverElem).is(evt.$el) && !$(this.curElem.$currentElem).is(evt.$el)) {
        $(evt.$el).css('outline', '2px solid pink');
        if (this.curElem.$hoverElem && !$(this.curElem.$hoverElem).is(this.curElem.$currentElem)) {
          $(this.curElem.$hoverElem).css('outline', 'none');
        }
        this.curElem.$hoverElem = evt.$el;
      }
    });
    this.subscribeEvent('forge:block:mouseleave', evt => {
      if ($(this.curElem.$hoverElem).is(evt.$el) && !$(this.curElem.$currentElem).is(evt.$el)) {
        $(this.curElem.$hoverElem).css('outline', 'none');
        this.curElem.$hoverElem = null;
      }
    });
    this.subscribeEvent('forge:block:mousedown', evt => {
      $('#clicked-elems').empty();
    });
    // Let's say user clicks on an image (for ex.),
    // we really get several forge:block:mouseup evts because there were probably
    // container blocks as well which the event will propagate to.
    this.subscribeEvent('forge:block:mouseup', this.setContextMenu);
  },
  setContextMenu: function (evt) {
    const model = {
      evt: evt,
      blockType: evt.$el[0].getAttribute('data-forge-type'),
      appendToId: 'clicked-elems',
      atomArr: evt.atomArr,
      level: 0,
      zIndex: 1000,
      forgeEditor: this,
      usingBrowserEditor: this.browserEditor !== undefined,
    };
    // eslint-disable-next-line no-unused-vars
    const menuItem = new ForgeMenuItemView(model);
  },
  setCurElem: function ($curElem) {
    if (this.curElem.$currentElem && this.curElem.$currentElem[0] !== $curElem[0]) {
      $(this.curElem.$currentElem).css('outline', 'none');
      $($curElem).css('outline', '1px solid #5588cc');
      this.curElem.$currentElem = $curElem;
    }
  },
  makeView: function (model, xpath, operation, objPath) {
    if (!xpath) {
      return;
    }
    // First, we have to remove the old (current) block from the DOM
    // If not, we get problems when we render the new blocks because 2 identical
    // elements might be in the DOM competing against each other.
    const $tempDiv = $('<div id="_tmpForgeDiv_"></div>');
    this.curElem.currentElem = this.getElementByXPath(xpath);
    if (operation === 'replace') {
      this.curElem.currentElem.replaceWith($tempDiv[0]);
    }
    // Now we can render our new blocks to a tmp location since old block is no longer in DOM
    const blockName = `tmp-forge-blocks-${this.seqno}`;
    const forgeHolderId = `tmp-forge-holder-${this.seqno}`;
    this.seqno += 1;
    $('#site-container').append(`<div id="${forgeHolderId}"  data-region="${blockName}"></div>`);
    const modelToMake = new Chaplin.Model(model);
    modelToMake.get('blocks').forge_path = objPath;
    this.model = modelToMake;
    const newBlocksView = new BlocksView({
      collection: new Chaplin.Collection(modelToMake.get('blocks')),
      container: `#${forgeHolderId}`,
      pageView: this,
    });
    // Must recursively call play() on all subviews if applicable
    setTimeout(() => {
      this.traverseSubviews(newBlocksView.subviews);
    }, 0);
    // Grab the new blocks and replace / insert / append
    const $newElem = $(`#${forgeHolderId}`).detach().find('[data-forge-type]').first();
    $(this.curElem.$currentElem).css('outline', 'none');
    if (operation === 'replace') {
      $tempDiv[0].replaceWith($newElem[0]);
      this.curElem.$currentElem = $newElem;
    } else if (operation === 'before') {
      this.curElem.$currentElem = $(this.curElem.currentElem);
      this.curElem.$currentElem.before($newElem);
    } else if (operation === 'after') {
      this.curElem.$currentElem = $(this.curElem.currentElem);
      this.curElem.$currentElem.after($newElem);
    }
    $(this.curElem.$currentElem).css('outline', '1px solid #5588cc');
    // Need this for apex-charts, probably others as well
    window.dispatchEvent(new Event('resize'));
  },
  traverseSubviews(subviews) {
    for (let i = 0; i < subviews.length; i++) {
      if (subviews[i].play) {
        subviews[i].play();
      }
      this.traverseSubviews(subviews[i].subviews);
    }
  },
  convertObjPathToXPath: function (objPath, contentRegion) {
    const $el = $(`${contentRegion} [data-forge-path="${objPath}"]`);
    if ($el.length > 0) {
      return this.getXPathTo($el.get(0));
    } else {
      return false;
    }
  },
  // This will inject new locales - key / value pairs - into the SDK from Forge
  addLocales: function (localeObj) {
    const { module, activity, page } = CustomPageService.modulePaths();
    // Pass YML like below - key / value objects

    // localeObj:
    //   header1: This is header One
    //   textField2: This is text field two
    //   textField3: This is text field three
    if (localeObj) {
      Object.entries(localeObj).forEach(([code, data]) => {
        LocaleService.addResource('en', `${module}.${activity}.${page}`, {
          [module]: {
            [activity]: {
              [page]: data,
            },
          },
        });
      });
    }
  },
  setPostMessage: function () {
    window.addEventListener('message', this.postMessageCallback.bind(this));
  },
  postMessageCallback: function (evt) {
    // when the course is not framed, window.parent is this window and our own posts come straight back
    if (evt.data?.sender === 'sdkForge') {
      return;
    }
    const { data: { locale, model, htmlExport } } = evt;

    if (locale) {
      this.addLocales(evt.data.locale);
    }

    if (model) {
      let { data: { xpath } } = evt;
      const { data: { objPath, contentRegion, operation } } = evt;

      if (objPath) {
        xpath = this.convertObjPathToXPath(objPath, contentRegion);
      }
      if (xpath) {
        this.makeView(model, xpath, operation, objPath);
      }
    }

    if (htmlExport) {
      this.exportBlocks(htmlExport);
    }
  },
  exportBlocks: function (htmlExport) {
    // one export at a time: a request without a scope, or made while one is rendering, is dropped
    if (!htmlExport.scope || this.exportInProgress) {
      return;
    }
    this.exportInProgress = true;
    const finish = reply => {
      this.stopListening(this, 'block:export:completed');
      this.stopListening(this, 'block:export:failed');
      this.exportInProgress = false;
      this.postToForge({ ...htmlExport, ...reply });
    };
    // listen before exporting so a synchronous completion is not missed
    this.listenToOnce(this, 'block:export:completed', (content, meta) => finish({ content, meta }));
    this.listenToOnce(this, 'block:export:failed', error => finish({ error: error?.message ?? String(error) }));
    new BlockExporter({ mode: htmlExport.mode }).exportBlocks(htmlExport.scope, this);
  },
  postToForge: function (htmlExport) {
    window.parent?.postMessage({
      htmlExport,
      sender: 'sdkForge'
    }, '*');
  },
});
export default ForgeEditorView;
